import CreatorProfile from "./CreatorProfile";

export default function RhythmAndSoulPatrolProfile() {
  return (
    <CreatorProfile
      creatorId={18}
      categoryLabel="Music & Live Events"
      onlyMemberzSlug="rhythmandsoulpatrol"
      tags={["Music", "Live Events", "Talent Patrol", "Detroit"]}
    />
  );
}